import React, { useEffect, useContext, useState, useRef } from "react";
import {
  Row,
  Col,
  CardBody,
  Container,
  CardTitle,
  Label,
  Card,
  Input,
  InputGroup
} from "reactstrap";
import _ from "lodash";
import Select from "react-select";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import helper from "services/helper";

const flatpickrDateOptions = {
  altInput: true,
  altFormat: "Y-m-d",
  dateFormat: "Y-m-d",
  clickOpens: true,
  allowInput: true
}

function DateRangeFields({ start, end, disabled, onCloseDate, value }) {
  const [openState, setOpenState] = useState({ start: false, end: false })
  const valueWhenOpenedRef = useRef({ start: null, end: null })

  const convertValue = (_value = null) => {
    if (_value) return moment(_value).toDate()
    return null
  }

  const handleStartOpen = () => {
    valueWhenOpenedRef.current.start = convertValue(start)
    setOpenState(prev => ({ ...prev, start: true }))
  }
  const handleStartClose = (selectedDates, dateStr, instance) => {
    setOpenState(prev => ({ ...prev, start: false }))
    onCloseDate(selectedDates, dateStr, instance, 'start', value)
  }
  const handleEndOpen = () => {
    valueWhenOpenedRef.current.end = convertValue(end)
    setOpenState(prev => ({ ...prev, end: true }))
  }
  const handleEndClose = (selectedDates, dateStr, instance) => {
    setOpenState(prev => ({ ...prev, end: false }))
    onCloseDate(selectedDates, dateStr, instance, 'end', value)
  }

  const startValue = openState.start ? valueWhenOpenedRef.current.start : convertValue(start)
  const endValue = openState.end ? valueWhenOpenedRef.current.end : convertValue(end)

  const startOptions = {
    ...flatpickrDateOptions,
    ...(end ? { maxDate: convertValue(end) } : {})
  }
  const endOptions = {
    ...flatpickrDateOptions,
    ...(start ? { minDate: convertValue(start) } : {})
  }

  return (
    <>
      <div className="col-md-3">
        <InputGroup>
          <Flatpickr
            className="form-control d-block"
            placeholder="Start Date"
            value={startValue}
            onOpen={handleStartOpen}
            onClose={handleStartClose}
            disabled={disabled}
            options={startOptions}
          />
        </InputGroup>
      </div>
      <div className="col-md-3">
        <InputGroup>
          <Flatpickr
            className="form-control d-block"
            placeholder="End Date"
            value={endValue}
            onOpen={handleEndOpen}
            onClose={handleEndClose}
            disabled={disabled}
            options={endOptions}
          />
        </InputGroup>
      </div>
    </>
  )
}

const OperatorInput = ({
  labelInput = "FORM",
  type = "TEXT",
  operator = "",
  value = [],
  option = [],
  disabled = false,
  onChange = () => console.log("onChange"),
}) => {


  // console.log("🚀 ~ OperatorInput type:", type)
  // console.log("🚀 ~ OperatorInput operator:", operator)
  // console.log("🚀 ~ OperatorInput value:", value)


  if (type === "DATE") {
    if (operator === "BETWEEN" || operator === "NOT_BETWEEN" ) {
      // console.log("🚀 ~ OperatorInput type:", type)
      // console.log("🚀 ~ OperatorInput operator:", operator)
      // console.log("🚀 ~ OperatorInput value:", value)

      const  [ start = null, end = null ] = value

      const applyDateChange = (dateValue, from = '', oldValue = []) => {
        const [ tmpStart = null, tmpEnd = null ] = oldValue
        if (!dateValue || !moment(dateValue).isValid()) return
        const newValue = moment(dateValue).format('YYYY-MM-DD')
        const updateState = from === 'start' ? [ newValue, tmpEnd ] : [ tmpStart, newValue ]
        onChange(updateState)
      }

      const onCloseDate = (selectedDates, dateStr, instance, from = '', oldValue = []) => {
        if (selectedDates && selectedDates.length > 0) {
          applyDateChange(selectedDates[0], from, oldValue)
        } else if (dateStr) {
          const parsedDate = moment(dateStr, 'YYYY-MM-DD', true)
          if (parsedDate.isValid()) {
            applyDateChange(parsedDate.toDate(), from, oldValue)
          }
        }
      }

      return (
        <DateRangeFields
          start={start}
          end={end}
          disabled={disabled}
          value={value}
          onCloseDate={onCloseDate}
        />
      );
    }
  }


  if (type === "ID") {
    if (operator === "OR" || operator === "NOT_OR" || operator === "AND") {
      const values = value
      const onChangeID = (event) => {
        const newValues = _.cloneDeep(event)
        let updateState = newValues.map(item => item.id)
        onChange(updateState)
      }

      const convertIDValue = (_values = [], _option = []) => {
        if (_values && _values.length) {
          return _option.filter(item => _values.includes(item.id))
        }
        return []
      }

      return (
        <div className="col-md-6">
          <Select
            className="select2-selection"
            isMulti={true}
            value={convertIDValue(values, option)}
            onChange={(e) => onChangeID(e)}
            getOptionValue={(option) => option.id}
            getOptionLabel={(option) => option.name}
            options={option}
            isDisabled={disabled}
          />
        </div>
      )
    }
  }

  if (type === "BOOLEAN") {
    if (operator === "=" ) {
      const  [ _value ] = value
      // const _value = "false"
      const onChangeBoolean = (value) => {
      console.log("BOOLEAN X onChangeBoolean ~ event:", value)
      console.log("BOOLEAN X onChangeBoolean ~ event checked: ", value)
      let updateState = [ value ]
      onChange(updateState)

      }

      const convertBooleanValue = (_value = null) => {
        if (_value != null) {
          return `${_value}`
        }
        return null
      }
      // console.log('BOOLEAN X _value >>', _value)
      return (
        <div className="col-md-6" style={{ display: 'flex', alignItems: 'center', pointerEvents: disabled ? 'none' : 'auto' }}>
          <div className="form-check form-check-inline" onClick={() => onChangeBoolean("true")}>
            <Input
              type="radio"
              id={`customRadioInline1_${Math.random()}`}
              className="form-check-input"
              name={`booleanOption_boolean_${Math.random()}`}
              value="true"
              // onChange={(e) => onChangeBoolean(e)}
              checked={convertBooleanValue(_value) === "true"}
              disabled={disabled}
            />
            <label className="form-check-label" htmlFor={`customRadioInline1_${Math.random()}`}>True</label>
          </div>
          <div className="form-check form-check-inline" onClick={() => onChangeBoolean("false")}>
            <Input
              type="radio"
              className="form-check-input"
              id={`customRadioInline2_${Math.random()}`}
              name={`booleanOption_boolean_${Math.random()}`}
              value="false"
              // onChange={(e) => onChangeBoolean(e)}
              // checked={_value === "false"}
              checked={convertBooleanValue(_value) === "false"}
              disabled={disabled}
            />
            <label className="form-check-label" htmlFor={`customRadioInline2_${Math.random()}`}>False</label>
          </div>
        </div>
      )
    }
  }

  if (type === "ENUM") {
    if (operator === "OR" || operator === "NOT_OR") {
      const values = value
      const onChangeEnum = (selectedValue = {}, oldValues = [], option = [], mode = "") => {
        console.log("🚀 ~ onChangeEnum ~ selectedValue:", selectedValue)
        const selectedId = selectedValue?.id
        const tmpOldValues = _.cloneDeep(oldValues)
        const findOldValue = tmpOldValues.filter(id => id === selectedId)

        let updateState = []
        if ( findOldValue && findOldValue.length) {
          updateState = tmpOldValues.filter(id => id != selectedId)
        } else {
          updateState = tmpOldValues
          updateState.push(selectedId)
        }
        // let updateState = newValues.map(item => item.id)
        

        if (mode === "all") {
          if (tmpOldValues.length >= option.length) {
            updateState = []
          } else {
            updateState = option.map(item => item.id)
          }
  
        }
        console.log("🚀 ~ onChangeEnum ~ updateState:", updateState)
        onChange(updateState)
      }
      const convertEnumValue = (_values = [], currentId = null) => {
        const arrChecked = _values.filter(item => item ==  currentId)
        console.log("🚀 ~ convertEnumValue ~ currentId:", currentId)
        console.log("🚀 ~ convertEnumValue ~ _values:", _values)
        console.log("🚀 ~ convertEnumValue ~ arrChecked:", arrChecked)
        if (arrChecked && arrChecked.length) {
          return true
        }
        return false
      }

      return (
        <div className="col-md-6" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div 
            style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '65px', pointerEvents: disabled ? 'none' : 'auto'  }}
            onClick={(e) => onChangeEnum({}, value, option, "all")}
          >
            <input
              type="checkbox"
              className="form-check-input"
              style={{ margin: 0 }}
              name="inputCheck"
              
              checked={values.length === option.length}
              disabled={disabled}
            />
            <label
              className="form-check-label"
            >
              All
            </label>
          </div>
          {
            option.map((item) => {
                return (
                  <div 
                    key={item.id} 
                    style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '65px', pointerEvents: disabled ? 'none' : 'auto' }}
                    onClick={(e) => onChangeEnum(item, values, option)}
                  >
                    <input
                      type="checkbox"
                      className="form-check-input"
                      style={{ margin: 0 }}
                      name="inputCheck"
                      checked={convertEnumValue(values, item.id) }
                      disabled={disabled}
                    />
                    <label
                      className="form-check-label"
                    >
                      {item.name}
                    </label>
                  </div>
                );
              })
            }
        </div>
        
      )
    }
  }

  if (type === "NUMBER") {
    if (operator === "=" || operator === "<" || operator === ">" ) {
      const  [ _value = 0 ] = value
      // // const _value = "false"
      const onChangeNumber = (event) => {
      console.log("🚀 ~ onChangeNumber ~ event:", event)
      console.log("🚀 ~ onChangeNumber ~ event value:", event.target.value)
      let updateState = [ event.target.value ]
      onChange(updateState)

      }

      return (
        <div className="col-md-3">
          <Input
            type="text"
            maxLength="255"
            name="number"
            value={_value}
            onInput={(e)=> helper.FNFORM.handleNumberOnly(e)}
            onChange={(e) => onChangeNumber(e)}
            disabled={disabled}
          />
        </div>
      )
    }

    else if (operator === "BETWEEN" || operator === "NOT_BETWEEN") {
      const  [ start = 0, end = 0] = value

      const onChangeNumberTwin = (event, from = '', oldValue = []) => {
        const [ tmpStart = null, tmpEnd = null ] = oldValue

        console.log("🚀 ~ onChangeNumber ~ event:", event)
        console.log("🚀 ~ onChangeNumber ~ event value:", event.target.value)

        const newValue = event.target.value
        let updateState = []
        if (from === 'start') {
          updateState = [ newValue, tmpEnd ]
        }
        else if (from === 'end') {
          updateState = [ tmpStart, newValue ]
        }
        onChange(updateState)

      }

      return (
        <>
          <div className="col-md-3">
            <Input
              type="text"
              maxLength="255"
              name="numberStart"
              value={start}
              onInput={(e)=> helper.FNFORM.handleNumberOnly(e)}
              onChange={(e) => onChangeNumberTwin(e, 'start', value)}
              disabled={disabled}
            />
          </div>
          <div className="col-md-3">
            <Input
              type="text"
              maxLength="255"
              name="numberEnd"
              value={end}
              onInput={(e)=> helper.FNFORM.handleNumberOnly(e)}
              onChange={(e) => onChangeNumberTwin(e, 'end', value)}
              disabled={disabled}
            />
          </div>
        </>
        
      )
    }
  }

  if (type === "PERIOD") {
    const [numberStart = 0, numberEnd = 0, dateStart = null, dateEnd = null] = value;
  
    const onChangeNumberTwin = (event, from = "", oldValue = []) => {
      const [tmpNumberStart, tmpNumberEnd, tmpDateStart, tmpDateEnd] = oldValue;
      const newValue = event.target.value;
      let updateState = [];
  
      if (from === "numberStart") {
        updateState = [newValue, tmpNumberEnd, tmpDateStart, tmpDateEnd];
      } else if (from === "numberEnd") {
        updateState = [tmpNumberStart, newValue, tmpDateStart, tmpDateEnd];
      }
  
      onChange(updateState);
    };
  
    const onChangeDate = (date, from = "", oldValue = []) => {
      const [tmpNumberStart, tmpNumberEnd, tmpDateStart, tmpDateEnd] = oldValue;
      
      // Handle both Date object and array of dates from Flatpickr
      let dateValue = date;
      if (Array.isArray(date) && date.length > 0) {
        dateValue = date[0];
      }
      
      // Validate date before processing
      if (!dateValue || !moment(dateValue).isValid()) {
        return;
      }
      
      const formattedDate = moment(dateValue).format("YYYY-MM-DD");
      let updateState = [];
  
      if (from === "dateStart") {
        updateState = [tmpNumberStart, tmpNumberEnd, formattedDate, tmpDateEnd];
      } else if (from === "dateEnd") {
        updateState = [tmpNumberStart, tmpNumberEnd, tmpDateStart, formattedDate];
      }
  
      onChange(updateState);
    };
    
    const onCloseDate = (selectedDates, dateStr, instance, from = "", oldValue = []) => {
      // This handles manual input when user finishes typing
      if (selectedDates && selectedDates.length > 0) {
        onChangeDate(selectedDates[0], from, oldValue);
      } else if (dateStr) {
        // Try to parse the date string if selectedDates is empty but dateStr exists
        const parsedDate = moment(dateStr, 'YYYY-MM-DD', true);
        if (parsedDate.isValid()) {
          onChangeDate(parsedDate.toDate(), from, oldValue);
        }
      }
    };
  
    const convertDateValue = (_value) => {
      return _value ? moment(_value).toDate() : null;
    };
  
    if (operator === "=" || operator === "<" || operator === ">") {
      return (
        <>
          <div className="col-md-1">
            <Input
              type="text"
              maxLength="255"
              name="number"
              value={numberStart}
              onInput={(e) => helper.FNFORM.handleNumberOnly(e)}
              onChange={(e) => onChangeNumberTwin(e, "numberStart", value)}
              disabled={disabled}
            />
          </div>
          <div className="col-md-2">
            <InputGroup>
              <Flatpickr
                className="form-control d-block"
                placeholder="Start Date"
                value={convertDateValue(dateStart)}
                onChange={(date) => onChangeDate(date, "dateStart", value)}
                onClose={(selectedDates, dateStr, instance) => onCloseDate(selectedDates, dateStr, instance, "dateStart", value)}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d",
                  maxDate: convertDateValue(dateEnd),
                  allowInput: true
                }}
                disabled={disabled}
              />
            </InputGroup>
          </div>
          <div className="col-md-2">
            <InputGroup>
              <Flatpickr
                className="form-control d-block"
                placeholder="End Date"
                value={convertDateValue(dateEnd)}
                onChange={(date) => onChangeDate(date, "dateEnd", value)}
                onClose={(selectedDates, dateStr, instance) => onCloseDate(selectedDates, dateStr, instance, "dateEnd", value)}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d",
                  minDate: convertDateValue(dateStart),
                  allowInput: true
                }}
                disabled={disabled}
              />
            </InputGroup>
          </div>
        </>
      );
    } else if (operator === "BETWEEN" || operator === "NOT_BETWEEN") {
      return (
        <>
          <div className="col-md-1">
            <Input
              type="text"
              maxLength="255"
              name="numberStart"
              value={numberStart}
              onInput={(e) => helper.FNFORM.handleNumberOnly(e)}
              onChange={(e) => onChangeNumberTwin(e, "numberStart", value)}
              disabled={disabled}
            />
          </div>
          <div className="col-md-1">
            <Input
              type="text"
              maxLength="255"
              name="numberEnd"
              value={numberEnd}
              onInput={(e) => helper.FNFORM.handleNumberOnly(e)}
              onChange={(e) => onChangeNumberTwin(e, "numberEnd", value)}
              disabled={disabled}
            />
          </div>
          <div className="col-md-2">
            <InputGroup>
              <Flatpickr
                className="form-control d-block"
                placeholder="Start Date"
                value={convertDateValue(dateStart)}
                onChange={(date) => onChangeDate(date, "dateStart", value)}
                onClose={(selectedDates, dateStr, instance) => onCloseDate(selectedDates, dateStr, instance, "dateStart", value)}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d",
                  maxDate: convertDateValue(dateEnd),
                  allowInput: true
                }}
                disabled={disabled}
              />
            </InputGroup>
          </div>
          <div className="col-md-2">
            <InputGroup>
              <Flatpickr
                className="form-control d-block"
                placeholder="End Date"
                value={convertDateValue(dateEnd)}
                onChange={(date) => onChangeDate(date, "dateEnd", value)}
                onClose={(selectedDates, dateStr, instance) => onCloseDate(selectedDates, dateStr, instance, "dateEnd", value)}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d",
                  minDate: convertDateValue(dateStart),
                  allowInput: true
                }}
                disabled={disabled}
              />
            </InputGroup>
          </div>
        </>
      );
    }
  }
  

  // if (type === "TEXT") {
  //   if (operator === "OR" || operator === "NOT_OR") {
  //     const values = value
  //     const onChangeID = (event) => {
  //       const newValues = _.cloneDeep(event)
  //       let updateState = newValues.map(item => item.id)
  //       onChange(updateState)
  //     }

  //     const convertIDValue = (_values = [], _option = []) => {
  //       if (_values && _values.length) {
  //         return _option.filter(item => _values.includes(item.id))
  //       }
  //       return []
  //     }

  //     return (
  //       <div className="col-md-6">
  //         <Select
  //           className="select2-selection"
  //           isMulti={true}
  //           value={convertIDValue(values, option)}
  //           onChange={(e) => onChangeID(e)}
  //           getOptionValue={(option) => option.id}
  //           getOptionLabel={(option) => option.name}
  //           options={option}
  //         />
  //       </div>
  //     )
  //   }
  // }




  return <></>

};
export default OperatorInput;
